import { FieldType, Lang } from '../type';
import { I18N_CHANGE_LABEL } from '../util';
export const schema = {
    id: 'page',
    name: get => `【${get('name')}（${get('path')}）】`,
    pickFields: ['pageConfig', 'title', 'i18nPatch'],
    fields: {
        i18nPatch: { name: I18N_CHANGE_LABEL },
        pageConfig: {
            type: FieldType.Array,
            idField: 'id',
            name: '页面',
            itemName: get => `${get('name')}（${get('id')}）`,
            detailUncheckable: true,
            details: {
                lessCode: {
                    name: 'LessCode',
                    lang: Lang.Javascript,
                    weak: true,
                },
                layout: { name: '页面布局', weak: true },
                i18nPatch: { name: I18N_CHANGE_LABEL, weak: true },
                xySources: { name: '页面数据', weak: true },
            },
        },
    },
};
